export default __webpack_public_path__ + "static/media/passport_1.65104ad0.jpg";